<template>
	<div id="app">
		<router-view></router-view>
		
		<loading v-if="loading"></loading>
	</div>
</template>
<!-- 11 -->
<script>
	import Login from './utils/login.js';
	import { mapState } from 'vuex';
	
	export default {
		created() {
			!this.whetherPc()
			&& location.replace('http://mobile.uflyvision.com');
			Login.init();
		},
		mounted() {
			document.getElementById('window_loading').remove();
			this.insertBaidu();
		},
		methods: {
			// 判断是否是pc端
			whetherPc() {
				var userAgentInfo = navigator.userAgent;
				var Agents = [ 'Android', 'iPhone', 'SymbianOS', 'Windows Phone','iPad', 'iPod' ];
				var flag = true;
				for (var v = 0; v < Agents.length; v++) {
					if (userAgentInfo.indexOf(Agents[v]) > 0) {
						flag = false;
						break;
					}
				}
				return flag;
			},
			// 引入百度统计
			insertBaidu() {
				var _hmt = _hmt || [];
				var hm = document.createElement("script");
				hm.src = "https://hm.baidu.com/hm.js?45a2425c1256a09509531bd1954df366";
				var s = document.getElementsByTagName("script")[0]; 
				s.parentNode.insertBefore(hm, s);
			}
		},
		watch: {
			$route: {
				handler() {
					let ele = document.documentElement || document.body;
					ele.scrollTop = 0;
				},
				deep: true
			}
		},
		computed: {
			...mapState([
				'loading'
			])
		}
	}
</script>

<style>
	/*css 初始化 */
	html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, menu, nav, output, ruby, section, summary, time, mark, audio, video, input, textarea, button, select{ box-sizing: border-box;margin: 0;padding: 0;border: none;outline:none;word-break: break-all;background: transparent; }
	html{ overflow-x: hidden; }
	body{ min-width: 1200px;background: #fff;overflow-x: hidden;font-family: '思源黑体', 'Helvetica Neue', Helvetica, Arial, sans-serif;font-weight: normal;font-size: 14px;color: #000;line-height: 24px; }
	h1,h2,h3,h4,h5,h6,input,button,textarea,th,a,select{ font-size: 14px;color: #000;font-weight: normal; }
	fieldset, img, input, button { border: none;padding: 0;margin: 0;outline-style: none; }
	button { display: inline-block;position: relative;background: #2b53c6;color: #fff;overflow: hidden;vertical-align: top; }
	button.disabled{ background: #dcdcdc;color: #030303; }
	button:focus{ outline: none; }
	button::after{ content: "";display: block;position: absolute;top: 0;left: 0;right: 0;bottom: 0;pointer-events: none;background-color: #ccc;opacity: 0;transition: all .3s; }
	button:active::after{ opacity: .3;transition: 0s; }
	ul, ol { list-style: none; }
	select, input, textarea { border: none;outline:none;background: transparent; }
	textarea { outline:none;resize: none; }
	video{ border: none;outline: none; }
	
	/*防止拖动*/
	img { border: 0;vertical-align: top; }
	/*  去掉图片低测默认的3像素空白缝隙*/
	table { border-collapse: collapse;border-spacing: 0; }
	a { display: inline-block;position: relative;text-decoration: none;vertical-align: top; }
	a:hover,button:hover{ cursor: pointer; }
	s, i, em { font-style: normal;text-decoration: none; }
	
	.clear{ height: 0; line-height: 0; font-size: 0; clear: both;}
	.clear_both::after{content: ""; display: block; height: 0; clear: both; visibility: hidden; font-size: 0;}
	
	.text_one{ overflow: hidden;text-overflow:ellipsis;white-space: nowrap; }
	.text_two{ display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden; }
	.text_three{ display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden; }
	.text_four{ display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 4;overflow: hidden; }
	.text_five{ display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 5;overflow: hidden; }
	
	.text_theme{ color: #2b53c6!important; }
	.text_underline::after{ content: '';display: block;position: absolute;width: 100%;height: 3px;bottom: 0;left: 0;background: #2b53c6; }
	.bg_theme{ background-color: #2b53c6!important; }
	.border_theme{ border-color: #2b53c6!important; }
	
	/* .border_t{ border-top: 1px solid #8b8b8b; }
	.border_r{ border-right: 1px solid #8b8b8b; }
	.border_b{ border-bottom: 1px solid #8b8b8b; }
	.border_l{ border-left: 1px solid #8b8b8b; } */
	
	.border_t::before{ content: '';display: block;position: absolute;width: 100%;height: 1px;top: 0;left: 0;background: #ededed; }
	.border_r::after{ content: '';display: block;position: absolute;width: 1px;height: 100%;top: 0;right: 0;background: #ededed; }
	.border_b::after{ content: '';display: block;position: absolute;width: 100%;height: 1px;bottom: 0;left: 0;background: #ededed; }
	.border_l::before{ content: '';display: block;position: absolute;width: 1px;height: 100%;top: 0;left: 0;background: #ededed; }
	
	.base_checkbox{ display: inline-block;width: 35px;height: 35px;border: 1px solid #8b8b8b;vertical-align: top;cursor: pointer; }
	.base_checkbox_on{ border: 1px solid #2b53c6;background-image: url(./assets/check_icon.png);background-size: 100% 100%; }
	
	.fade_transition-enter-active,.fade_transition-leave-active {
		transition: opacity .175s ease-out;
	}
	.fade_transition-enter,.fade_transition-leave-to {
		opacity: 0;
	}
	
	.scale_transition-enter-active,.scale_transition-leave-active {
		transition: all .175s ease-out;
	}
	.scale_transition-enter, .scale_transition-leave-to {
		transform: scale(0, 0);
	}
	
	.translate_transition-enter-active,.translate_transition-leave-active {
		transition: all .175s ease-out;
	}
	.translate_transition-enter, .translate_transition-leave-to {
		transform: translateY(200px);
		opacity: 0;
	}
</style>
